module.exports = __webpack_public_path__ + "img/dulux-nz-logo.8b6c7a89.png";